import { useState } from 'react';
import { UserManagementPanel, RoleManagementPanel } from 'auth-sso-kit/client';
import { AuditLogViewer } from 'audit-log-kit/client/index.js';
import { useAccent } from '../context/AccentContext';

const ACCENTS = [
  { nom: 'Teal', hex: '#0d7377' },
  { nom: 'Indigo', hex: '#1a1682' },
  { nom: 'Violet', hex: '#7c5cbf' },
  { nom: 'Rose', hex: '#c05580' },
  { nom: 'Slate', hex: '#4a5568' },
];

type Onglet = 'utilisateurs' | 'roles' | 'audit' | 'apparence';

export function AdminPage() {
  const [onglet, setOnglet] = useState<Onglet>('utilisateurs');
  const { accent, setAccent } = useAccent();

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Administration</h1>
          <p className="page-meta">Utilisateur·rices, rôles, journal d'audit, apparence</p>
        </div>
      </div>

      <div className="tabs mb-16">
        <button className={`tab${onglet === 'utilisateurs' ? ' active' : ''}`} onClick={() => setOnglet('utilisateurs')}>
          Utilisateur·rices
        </button>
        <button className={`tab${onglet === 'roles' ? ' active' : ''}`} onClick={() => setOnglet('roles')}>
          Rôles
        </button>
        <button className={`tab${onglet === 'audit' ? ' active' : ''}`} onClick={() => setOnglet('audit')}>
          Journal d'audit
        </button>
        <button className={`tab${onglet === 'apparence' ? ' active' : ''}`} onClick={() => setOnglet('apparence')}>
          Apparence
        </button>
      </div>

      {onglet === 'utilisateurs' && <UserManagementPanel />}
      {onglet === 'roles' && <RoleManagementPanel />}
      {onglet === 'audit' && <AuditLogViewer />}
      {onglet === 'apparence' && (
        <div className="card">
          <div className="card-header">
            <span className="card-title">Couleur d'accent</span>
          </div>
          <div className="p-16 flex gap-8 items-center">
            {ACCENTS.map((a) => (
              <span
                key={a.hex}
                className={`color-swatch${accent === a.hex ? ' active' : ''}`}
                style={{ background: a.hex }}
                title={a.nom}
                onClick={() => setAccent(a.hex)}
              />
            ))}
            <input
              type="color"
              className="form-input"
              style={{ width: 48, padding: 2 }}
              value={accent}
              onChange={(e) => setAccent(e.target.value)}
              title="Couleur personnalisée"
            />
          </div>
        </div>
      )}
    </div>
  );
}
